<span>{{valueA}}</span>
<span>{{valueB}}</span>